export default __webpack_public_path__ + "static/df6faf67bac50d9e7c921f9f5545234c.ttf";